import http from "@/http-common";

/* eslint-disable */
class MenuApprovalHistoryDataService {
    getMenuApprovalHistory(data: any): Promise<any> {
        return http.api.post("/getMenuApprovalHistory/", data);
    }

    getAllMainMenuInfo(): Promise<any> {
        return http.api.post("/getAllMainMenuInfo/");
    }

    revertApprovalStatus(data: any): Promise<any> {
        return http.api.post("/revertApprovalStatus/", data);
    }

}

export default new MenuApprovalHistoryDataService();
